function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ResizeObserver from 'resize-observer-polyfill';

/**
 * @constant {Object}
 */
var CAROUSEL_CLASSES = {
  HIDDEN_BUTTON_CLASS: 'mc-carousel-header__buttons--hidden',
  HIDDEN_SCROLLBAR_CLASS: 'mc-carousel__custom-scrollbar--hidden',
  DISABLED_BUTTON_CLASS: 'mc-carousel-header__button--disabled',
  CENTERED_ITEMS_CLASS: 'mc-carousel-body__item-list--center',
  NO_DRAG: 'no-drag',
  CAROUSEL_CONTAINER: 'js-carousel-container',
  CAROUSEL_CONTENT: 'js-carousel-content',
  CAROUSEL_ITEMS: 'js-carousel-item-list',
  CAROUSEL_CONTROLS: 'js-carousel-controls',
  CAROUSEL_BUTTON: 'js-carousel-button',
  CUSTOM_SCROLLBAR: 'js-scrollbar',
  CUSTOM_SCROLLBAR_THUMB: 'js-scrollbar-thumb'
};
var Carousel = /*#__PURE__*/function () {
  /**
   * @param {Element|string} elementOrSelector The DOM element or selector string for the carousel.
   * @param {Object} [options={}] options Additional configuration options.
   */
  function Carousel(elementOrSelector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Carousel);
    this.carousel = this.getCarousel(elementOrSelector);
    this.carouselItems = this.carousel.querySelectorAll(".".concat(CAROUSEL_CLASSES.CAROUSEL_ITEMS, " > li"));
    this.buttonsNavigation = this.carousel.querySelectorAll(".".concat(CAROUSEL_CLASSES.CAROUSEL_BUTTON));
    this.options = _objectSpread({
      centerWhenNoButtons: false
    }, options);
    this.scrollWidth = this.getFullWidth(this.carouselItems[0]);
    this.isDragging = false;
    this.initializeEventListeners();
    this.buttonsVisibility();
    this.initializeScrollbar();
  }
  /**
   * @param {HTMLElement|string} elementSelector The DOM element or selector string for the carousel
   * @returns {HTMLElement}
   */
  return _createClass(Carousel, [{
    key: "getCarousel",
    value: function getCarousel(elementSelector) {
      return typeof elementSelector === 'string' ? document.querySelector(elementSelector) : elementSelector;
    }
    /**
     * @param {HTMLElement} element The DOM element
     * @returns {number}
     */
  }, {
    key: "getFullWidth",
    value: function getFullWidth(element) {
      var elementStyle = window.getComputedStyle(element);
      return element.clientWidth + parseFloat(elementStyle.marginLeft) + parseFloat(elementStyle.marginRight) + parseFloat(elementStyle.paddingLeft) + parseFloat(elementStyle.paddingRight) + parseFloat(elementStyle.borderLeftWidth) + parseFloat(elementStyle.borderRightWidth);
    }
  }, {
    key: "initializeEventListeners",
    value: function initializeEventListeners() {
      var _this = this;
      new ResizeObserver(function () {
        _this.scrollWidth = _this.getFullWidth(_this.carouselItems[0]);
        _this.checkStatusButtons(_this.content, 0);
        _this.buttonsVisibility();
      }).observe(this.carousel);
      window.addEventListener('resize', this.updateThumbWidth.bind(this));
      if (!this.eventLoaded) {
        this.buttonsNavigation.forEach(function (button) {
          button.addEventListener('click', function (event) {
            return _this.swipe(event.target);
          });
        });
        this.eventLoaded = true;
      }
    }
  }, {
    key: "buttonsVisibility",
    value: function buttonsVisibility() {
      var carouselWidth = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_CONTENT)).offsetWidth;
      var carouselSlider = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_ITEMS));
      var carouselSliderWidth = carouselSlider.scrollWidth;
      var buttonsNavigation = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_CONTROLS));
      var scrollbar = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CUSTOM_SCROLLBAR));
      if (carouselSliderWidth > carouselWidth) {
        buttonsNavigation.classList.remove("".concat(CAROUSEL_CLASSES.HIDDEN_BUTTON_CLASS));
        carouselSlider.classList.remove("".concat(CAROUSEL_CLASSES.CENTERED_ITEMS_CLASS));
        scrollbar.classList.remove("".concat(CAROUSEL_CLASSES.HIDDEN_SCROLLBAR_CLASS));
      } else {
        buttonsNavigation.classList.add("".concat(CAROUSEL_CLASSES.HIDDEN_BUTTON_CLASS));
        scrollbar.classList.add("".concat(CAROUSEL_CLASSES.HIDDEN_SCROLLBAR_CLASS));
        if (this.options.centerWhenNoButtons) {
          carouselSlider.classList.add("".concat(CAROUSEL_CLASSES.CENTERED_ITEMS_CLASS));
        }
      }
    }
    /**
     * @param {HTMLElement} carouselScrollElement The DOM element of the carousel scroll container
     * @param {number} scrollValue The scroll value to be applied
     */
  }, {
    key: "checkStatusButtons",
    value: function checkStatusButtons(carouselScrollElement, scrollValue) {
      var limit = carouselScrollElement.scrollWidth - carouselScrollElement.clientWidth;
      var scrollPosition = carouselScrollElement.scrollLeft + scrollValue + 1;
      this.buttonsNavigation[0].classList.toggle(CAROUSEL_CLASSES.DISABLED_BUTTON_CLASS, scrollPosition <= 1);
      this.buttonsNavigation[1].classList.toggle(CAROUSEL_CLASSES.DISABLED_BUTTON_CLASS, scrollPosition >= limit);
      this.buttonsNavigation[0].toggleAttribute('disabled', scrollPosition <= 1);
      this.buttonsNavigation[1].toggleAttribute('disabled', scrollPosition >= limit);
    }
    /**
     * @param {HTMLElement} targetButton The DOM element for the navigation button
     */
  }, {
    key: "swipe",
    value: function swipe(targetButton) {
      var carousel = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_CONTENT));
      var partialItemWidth = 0;
      var isPrev = targetButton.dataset.controls === 'prev';
      var _iterator = _createForOfIteratorHelper(this.carouselItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var itemLeft = item.getBoundingClientRect().left;
          var carouselLeft = carousel.getBoundingClientRect().left;
          var itemRight = item.getBoundingClientRect().right;
          var carouselRight = carousel.getBoundingClientRect().right;
          if (isPrev) {
            if (itemLeft < carouselLeft && itemRight > carouselLeft) {
              partialItemWidth = itemRight - carouselLeft;
              break;
            }
          } else {
            if (itemLeft < carouselRight && itemRight > carouselRight) {
              partialItemWidth = carouselRight - itemLeft;
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var visibleWidth = carousel.offsetWidth;
      var scrollValue = isPrev ? (visibleWidth - partialItemWidth) * -1 : visibleWidth - partialItemWidth;
      this.showButton(carousel, scrollValue);
      carousel.scrollBy({
        top: 0,
        left: scrollValue,
        behavior: 'smooth'
      });
    }
    /**
     * @param {HTMLElement} scrollElement The DOM element of the carousel scroll container
     * @param {number} scrollValue The scroll value to be applied
     */
  }, {
    key: "showButton",
    value: function showButton(scrollElement, scrollValue) {
      this.checkStatusButtons(scrollElement, scrollValue);
    }
  }, {
    key: "initializeScrollbar",
    value: function initializeScrollbar() {
      this.container = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_CONTAINER));
      this.content = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CAROUSEL_CONTENT));
      this.scrollbar = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CUSTOM_SCROLLBAR));
      this.thumb = this.carousel.querySelector(".".concat(CAROUSEL_CLASSES.CUSTOM_SCROLLBAR_THUMB));
      this.updateThumbPosition();
      this.updateThumbWidth();
      this.thumb.addEventListener('mousedown', this.onThumbMouseDown.bind(this));
      this.scrollbar.addEventListener('click', this.onScrollbarClick.bind(this));
      this.content.addEventListener('scroll', this.updateThumbPosition.bind(this));
    }
    /**
     * @param {Event} event The mouse down event
     */
  }, {
    key: "onThumbMouseDown",
    value: function onThumbMouseDown(event) {
      var startX = event.pageX;
      var startScrollLeft = this.content.scrollLeft;
      this.isDragging = true;
      document.body.classList.add(CAROUSEL_CLASSES.NO_DRAG);
      document.addEventListener('mousemove', this.onMouseMove.bind(this, startX, startScrollLeft));
      document.addEventListener('mouseup', this.onMouseUp.bind(this));
    }
  }, {
    key: "updateThumbPosition",
    value: function updateThumbPosition() {
      var scrollRatio = this.content.scrollLeft / (this.content.scrollWidth - this.container.offsetWidth);
      this.thumb.style.left = "".concat(scrollRatio * (this.scrollbar.offsetWidth - this.thumb.offsetWidth), "px");
      this.checkStatusButtons(this.content, 0);
    }
  }, {
    key: "updateThumbWidth",
    value: function updateThumbWidth() {
      var ratio = this.container.offsetWidth / this.content.scrollWidth;
      this.thumb.style.width = "".concat(100 * ratio, "%");
    }
    /**
     * @param {number} startX The starting X coordinate of the mouse event
     * @param {number} startScrollLeft The initial scroll position
     * @param {Event} event The mouse move event
     */
  }, {
    key: "onMouseMove",
    value: function onMouseMove(startX, startScrollLeft, event) {
      if (!this.isDragging) return;
      event.preventDefault();
      var dx = event.pageX - startX;
      var maxThumbMove = this.scrollbar.offsetWidth - this.thumb.offsetWidth;
      var scrollRatio = dx / maxThumbMove;
      var scrollDifference = scrollRatio * (this.content.scrollWidth - this.container.offsetWidth) - this.content.scrollLeft + startScrollLeft;
      this.content.scrollBy({
        top: 0,
        left: scrollDifference,
        behavior: 'instant'
      });
      this.updateThumbPosition();
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      this.isDragging = false;
      document.body.classList.remove(CAROUSEL_CLASSES.NO_DRAG);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
    /**
     * @param {Event} event The click event on the scrollbar
     */
  }, {
    key: "onScrollbarClick",
    value: function onScrollbarClick(event) {
      if (event.target === this.thumb) return;
      var clickX = event.pageX - this.scrollbar.getBoundingClientRect().left;
      var thumbHalfWidth = this.thumb.offsetWidth / 2;
      var clickRatio = (clickX - thumbHalfWidth) / (this.scrollbar.offsetWidth - this.thumb.offsetWidth);
      this.content.scrollLeft = clickRatio * (this.content.scrollWidth - this.container.offsetWidth);
      this.updateThumbPosition();
    }
  }]);
}();
export default Carousel;